import fetch from '../../../utils/fetch';
import {PASSWORD_RECOVERY_RESET} from './mutation-types';
import {PASSWORD_RECOVERY, PASSWORD_RECOVERY_TOKEN} from '../../../constants/api-routes';

const getDefaultState = () => {
  return {};
};
const state = getDefaultState();

function reset() {
    return {type: PASSWORD_RECOVERY_RESET};
}

const getters = {};

const actions = {
    submit({commit}, {email = null, uri = null}) {
        commit(reset());
        let formData = new FormData();
        formData.set('email', email);
        formData.set('uri', uri);
        return fetch(PASSWORD_RECOVERY,
            {
                method: 'POST',
                data: formData
            });
    },
    submitWithToken({commit}, {password = null, token = null}) {
        commit(reset());
        let formData = new FormData();
        formData.set('token', token);
        formData.set('password', password);
        return fetch(PASSWORD_RECOVERY_TOKEN,
            {
                method: 'POST',
                data: formData
            });
    },
    reset({commit}) {
        commit(reset());
    }
};

const mutations = {
    [PASSWORD_RECOVERY_RESET](state) {
        Object.assign(state, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/password-recovery.js